import script from "./MenuVagasComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuVagasComponent.vue?vue&type=script&setup=true&lang=js"

import "./MenuVagasComponent.vue?vue&type=style&index=0&id=0c971938&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c971938"]])

export default __exports__